<template>
    <v-container class="chatsite pt-0 pb-0">
        <section>
            <header>
                <v-tabs v-model="active" fixed-tabs slider-color="black" v-if="renderComponent" show-arrows>
                    <v-tab v-for="row in _.sortBy($store.state.chat.kanaele, ['index'])" @click="getKanal(row.id, row.title, row.index)" :key="row.id" style="position:relative;">

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on">{{ row.icon }}</v-icon>
                                <div v-if="getUnreadedMessagesFromContract(row.id).length>0" class="v-badge__badge fakebubble">{{ getUnreadedMessagesFromContract(row.id).length }}</div>
                            </template>
                            <span>{{ row.title=='Chat' ? row.title : `Chat für: ${row.title}` }}</span>
                        </v-tooltip>
                        
                    </v-tab>
                  </v-tabs>
            </header>
            <chatTimeline ref="chatTimeline" :contract_id="contract_id" />
      </section>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import chatTimeline from '@/components/chatTimeline'

export default {
    data: () => ({
        isLoading: false,
        contract_id: 'system',
        renderComponent: true,
        active: 0
    }),

    components: {
        chatTimeline
    },

    created(){
        if(this.$store.getters['contracts/getContractByIndex'](0)){
            this.try2getChanel(this.$route.params.id ? this.$route.params.id : this.getFirstContractIdWithUnreadedMessanges);
        }else{
            setTimeout(() => {
                this.try2getChanel(this.$route.params.id ? this.$route.params.id : this.getFirstContractIdWithUnreadedMessanges);
            }, 1000);
        }
    },

    computed: {
        ...mapGetters('chat', [
            'getUnreadedMessagesFromContract',
            'getFirstContractIdWithUnreadedMessanges'
        ])
    },

    watch: {
        $route(to){
            this.try2getChanel(to.params.id);
        }
    },

    methods: {
        try2getChanel(contract_id = false){
            this.renderComponent = false;
            if(contract_id){
                if(contract_id!=''){
                    if(this.$store.state.chat.kanaele[contract_id]){
                        this.getKanal(contract_id, this.$store.state.chat.kanaele[contract_id].title, this.$store.state.chat.kanaele[contract_id].index);
                        return true;
                    }
                }
            }
            this.getKanal();
            return true;
        },

        getKanal(contract_id = 'system', title = 'Chat', index = 0){
            this.$route.meta.title = title;
            let new_path = `/chat/${contract_id}`;
            if(this.$router.history.current.fullPath!=new_path){
                this.$router.push({ path: `/chat/${contract_id}` });
            }
            this.active = Number(index);
            this.contract_id = contract_id;
            this.renderComponent = true;
        }
    }
}
</script>

<style scoped>
    .v-content__wrap>.container{
        max-height: calc(100vh - 7rem - 65px);
    }
    .v-tabs__container--fixed-tabs .v-tabs__div, .v-tabs__container--icons-and-text .v-tabs__div {
        min-width: 80px;
    }
    .v-badge__badge.fakebubble{
        top: 5px;
        right: 15px;
        background-color: #c53821;
    }
    .v-tabs__item--active>.theme--light.v-icon{
      color: #025dab;
    }


    @media screen and (max-width: 960px) {
        .v-content__wrap>.container{
            max-height: calc(100vh - 11rem - 65px);
        }
        .v-tabs__container--fixed-tabs .v-tabs__div, .v-tabs__container--icons-and-text .v-tabs__div {
            min-width: 65px;
        }
    }
</style>
